"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cBroadcastNotificationToListSchema = void 0;
var zod_1 = require("zod");
var hooks_1 = require("../../hooks");
var userLists_1 = require("../../userLists");
exports.cBroadcastNotificationToListSchema = zod_1.z.strictObject({
    event: zod_1.z.literal(hooks_1.HookName.broadcastNotificationToList),
    action: zod_1.z.literal(hooks_1.HookName.broadcastNotificationToList),
    meta: zod_1.z.optional(zod_1.z.strictObject({
        requester: zod_1.z.number()
    })),
    qaUrl: zod_1.z.optional(zod_1.z.string()),
    listMembershipState: zod_1.z.optional(zod_1.z.union([
        zod_1.z.literal(userLists_1.ListMembershipState.applied),
        zod_1.z.literal(userLists_1.ListMembershipState.accepted),
        zod_1.z.literal(userLists_1.ListMembershipState.rejected),
        zod_1.z.literal(userLists_1.ListMembershipState.completed),
        zod_1.z.literal(userLists_1.ListMembershipState.returned),
        zod_1.z.literal(userLists_1.ListMembershipState.withdrawn),
        zod_1.z.literal(userLists_1.ListMembershipState.banned),
    ])),
    templateName: zod_1.z.string(),
    listIds: zod_1.z.array(zod_1.z.string())
});
